import API from '@/services/api.js'
import merge from 'lodash/merge'

const actions = {
  //- Sets the current user on login
  setCurrentUser({ commit, dispatch }, user) {    
    //- Set user data (set/clear auth header and localstore)
    if (user) {
      API.setHeaders('Authorization', `Bearer ${user.token}`)
      localStorage.setItem('user', JSON.stringify(user))
      //-Matomo user set and REMOVE COMMENT WHEN IS NEEDED
      /* window._paq.push(['setUserId', user.email])
      window._paq.push(['trackPageView']) */
      dispatch('basic/loadBasics', {}, { root: true })
    } else {
      API.setHeaders('Authorization', null)
      localStorage.removeItem('user')
    }
    //- Mutate store
    commit('SET_CURRENT_USER', user)
  },

  updateCurrentUser({ commit }, user) {
    console.log('Store - updateCurrentUser')

    if (!user) {
      return
    }
    API.setHeaders('Authorization', `Bearer ${user.token}`)
    localStorage.setItem('user', JSON.stringify(user))

    //- Mutate store
    commit('SET_CURRENT_USER', user)
  },

  updateCurrentUserData({ commit }, user) {
    console.log('Store - updateCurrentUserData')

    //- Mutate store
    commit('UPDATE_CURRENT_USER', user)
  },

  loadCurrentUser({ dispatch }) {
    //- Try to grab user from localstorage and verify that data is correct
    console.log('Store - loadCurrentUser')

    // Grab user data from local storage
    const userString = localStorage.getItem('user')

    // check to see if there is indeed a user
    if (!userString) {
      //- No userstring in localstore
      console.log('Store - no localstore user data')
      return dispatch('setCurrentUser', null)
    }

    // parse user data into JSON and set API Auth headers
    let userData = null
    try {
      userData = JSON.parse(userString)
    } catch (e) {
      //- Somthing bad happende to localstore data
      console.log('Store - failed to parse localstore user data')
      return dispatch('setCurrentUser', null)
    }

    if (!(userData && userData.token)) {
      //- No parsable userdata in localstore
      console.log('Store - no token in user data')
      return dispatch('setCurrentUser', null)
    }

    //- Set Auth headers for requests
    API.setHeaders('Authorization', `Bearer ${userData.token}`)

    //- Handle the nobodys
    if (userData.id === -1) {
      console.log('Store - setting current user to -1')
      dispatch('setCurrentUser', userData)
      return
    }

    // Get user to see if we have correct credentials
    API.getPerson(userData.id)
      .then(res => {
        //- User stored in localstore was ok and we can proceed as logged in
        //- Save (ie. update values for) user in localStorge
        //- Token is only received when logging in, so keep that from stored user
        dispatch('setCurrentUser', merge(
          res.data, { 
            token: userData.token,
            imitatingUser: userData.imitatingUser
          }))
      })
      .catch(error => {
        //- User stored in localstore was not ok
        console.log('Store - failed to get user: ' + error)
        return dispatch('setCurrentUser', null)
      })
  },

  //- Sets fetched notifications
  setNotifications({ commit, dispatch }, notifications) {
    //- Mutate store
    commit('SET_NOTIFICATIONS', notifications)
  }
}

export default actions
